import React, {useContext, useEffect} from "react";
import { StepProps } from "../../QuotationForm/step-props";
import {forms} from "../forms";
import {TravelQuotation} from "../../../model/quotation";
import {ITravelQuotationContext, TravelQuotationContext} from "../../../contexts/TravelQuotationContext";

export const TravelVerificationStep = ({step}: StepProps) => {
    const {setCurrentStep} = useContext<ITravelQuotationContext>(TravelQuotationContext);
    useEffect(() => {
        setCurrentStep("travel_online_00003")
        document.body.classList.add('body-background-color-transparent')

        return () => {
            document.body.classList.remove('body-background-color-transparent')
        }
    }, [])

    const onVerify = (quotation: TravelQuotation, paymentPageUrl: string) => {
        let event = 'travel_identification';
        console.log('Google Analytics Event = ' + event);
        // @ts-ignore
        window.dataLayer.push({'event': event});

        localStorage.setItem("TRAVEL_expires_in", "1")

        window.location.href = paymentPageUrl;
    };

    return (
        <>
            {step.forms.map(form => {
                return React.createElement(forms[form.code], {
                    key: form.code,
                    onVerify
                })
            })}
        </>
    );
};
